<template>
  <div class="wait">
    <div class="wait-content">
      <div class="sk-folding-cube sk-primary" v-if="spinnerEnabled">
        <div class="sk-cube1 sk-cube"></div>
        <div class="sk-cube2 sk-cube"></div>
        <div class="sk-cube4 sk-cube"></div>
        <div class="sk-cube3 sk-cube"></div>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-wait',
  props: {
    spinnerEnabled: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style src="spinkit/scss/spinners/11-folding-cube.scss" lang="scss"></style>

<style lang="scss">
.wait {
  background: #f8f8f8;
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
